import React, { useEffect, useState } from 'react';

const SunnyEffect = () => {
    const [particles, setParticles] = useState({ beams: [], sparkles: [] });
    const isDay = new Date().getHours() >= 6 && new Date().getHours() < 18;

    useEffect(() => {
        if (!isDay) return; // No sunshine particles at night
        
        const beams = [];
        const sparkles = [];

        // Generate sun beams (long vertical streaks)
        for (let i = 0; i < 15; i++) {
            beams.push({
                id: `beam-${i}`,
                left: Math.random() * 100,
                delay: Math.random() * 10,
                duration: 15 + Math.random() * 10,
                opacity: 0.1 + Math.random() * 0.2
            });
        }

        // Generate sparkles (small twinkling bits)
        for (let i = 0; i < 40; i++) {
            sparkles.push({
                id: `sparkle-${i}`,
                left: Math.random() * 100,
                top: Math.random() * 100,
                delay: Math.random() * 5,
                duration: 3 + Math.random() * 4,
                size: 5 + Math.random() * 10
            });
        }

        setParticles({ beams, sparkles });
    }, [isDay]);

    return (
        <>
            {/* Global Sunshine Particles - active only in daytime */}
            {isDay && (
                <div className="sunshine-container">
                    {particles.beams.map(beam => (
                        <div
                            key={beam.id}
                            className="sunbeam"
                            style={{
                                left: `${beam.left}%`,
                                animationDelay: `${beam.delay}s`,
                                animationDuration: `${beam.duration}s`,
                                opacity: beam.opacity
                            }}
                        />
                    ))}
                    {particles.sparkles.map(sparkle => (
                        <div
                            key={sparkle.id}
                            className="sun-sparkle"
                            style={{
                                left: `${sparkle.left}%`,
                                top: `${sparkle.top}%`,
                                animationDelay: `${sparkle.delay}s`,
                                animationDuration: `${sparkle.duration}s`,
                                fontSize: `${sparkle.size}px`
                            }}
                        >
                            ✨
                        </div>
                    ))}
                </div>
            )}

            {/* Heat wave shimmer effect - rendered only during the day */}
            {isDay && <div className="heat-shimmer" />}

            {/* Warm glow overlay - rendered only during the day */}
            {isDay && <div className="sunny-glow" />}
        </>
    );
};

export default SunnyEffect;
